import { fillZero } from '.'


/**
 * 时间类型兼容，兼容「时间戳数字」「时间戳字符串」和「时间对象」
 * @param {string|number|Date} time 时间内容，可传入时间对象，或时间戳
 * @param {DealTimeType} type 期望返回的数据类型
 * @returns {string|Date} 时间对象或时间戳
 */
type TimeType = string | number | Date;
export function dealTime(time: TimeType | 0 | '', type?: 'string' | 'object'): number | Date | '' | null {
  if (type === undefined) {
    type = 'string'
  }
  if (!time) {
    return type === 'string' ? '' : null
  }
  if (time.toString().indexOf('/') > 0 || time.toString().indexOf('-') > 0) {
    time = new Date(time)
  } else if (typeof time === 'string' || typeof time === 'number') {
    let standTimeStampLength = 13 // 标准时间戳长度
    time = fillZero(time, standTimeStampLength, { isFillBack: true }) // 转化为标准的13位时间戳
    time = new Date(parseInt(time))
  }
  if (type === 'object') {
    return time
  } else {
    return time.getTime()
  }
}

/**
* 格式化时间
* @param {string|number|Date} date 时间内容，可传入时间对象，或时间戳
* @param {string} formatStr 格式模板
* @returns {string} 处理后的字符串
*/
export function formatTime(date: string | number | Date, formatStr?: string): string {
  if (formatStr === undefined) {
    formatStr = 'YYYY-MM-DD hh:mm:ss'
  }
  if (!date) {
    return ''
  }
  const nDate = dealTime(date, 'object')
  if (nDate === null || nDate.toString() === 'Invalid Date') {
    return ''
  }
  let formatType = {
    Y: nDate instanceof Date ? nDate.getFullYear() : 0,
    M: nDate instanceof Date ? nDate.getMonth() + 1 : 0,
    D: nDate instanceof Date ? nDate.getDate() : 0,
    h: nDate instanceof Date ? nDate.getHours() : 0,
    m: nDate instanceof Date ? nDate.getMinutes() : 0,
    s: nDate instanceof Date ? nDate.getSeconds() : 0,
  }
  return formatStr.replace(/Y+|M+|D+|h+|m+|s+/g, target => {
    return fillZero(formatType[target[0] as keyof typeof formatType], target.length, { truncate: true })
  })
}